<template>
    <div>
        <confirm-modal
            v-model="modalRemoverPaciente"
            @modalAcaoCancelar="fecharModalRemoverPaciente"
            @modalAcaoConfirmar="removerPacienteSalaEspera"
            :persistencia="true"
            mensagemInicial="Deseja realmente remover o paciente "
            :mensagemMeio="paciente.nome"
            mensagemFinal="da sala de espera?"
            text-confirmar="Remover"
        />
        <v-dialog v-model="model" max-width="720" scrollable @click:outside="fecharModal">
            <v-card>
                <v-toolbar dark color="primary" elevation="0">
                    <v-toolbar-title>Visualizar paciente</v-toolbar-title>
                    <v-spacer/>
                    <v-btn class="close__button" text @click="fecharModal" icon>
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-2">
                    <div class="container-card-paciente">
                        <v-container fluid grid-list-xl>
                            <v-row justify="space-between">
                                <v-col cols="12" md="10" sm="10" xs="6">
                                    <span style="font-size: 14px">Nome</span><br/>
                                    <label class="d-inline-block text-truncate max-text">{{ paciente.nome }}</label>
                                </v-col>
                                <v-col cols="12" md="1" sm="1" xs="3">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" @click="acessarFichaPaciente" icon color="primary">
                                                <v-icon size="50">mdi-account-box</v-icon>
                                            </v-btn>
                                        </template>
                                        Acessar ficha do paciente
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" md="1" sm="1" xs="3">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" @click="abrirModalRemoverPaciente" icon color="primary">
                                                <v-icon size="35">mdi-location-exit</v-icon>
                                            </v-btn>
                                        </template>
                                        Remover paciente da sala de espera
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Ortodontia</span><br/>
                                    <label>{{ paciente.ortodontia | formatarBoolean }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Implante</span><br/>
                                    <label>{{ paciente.implante | formatarBoolean }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>CPF/CNPJ</span><br/>
                                    <label>{{ paciente.cnpjCpf | formatarCpfCnpj }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Sexo</span><br/>
                                    <label>{{ paciente.sexo }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Telefone</span><br/>
                                    <label>{{ paciente.telefone }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Data Nascimento</span><br/>
                                    <label>{{ paciente.dataNascimento | filterDate }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Idade</span><br/>
                                    <label>{{ paciente.idade }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Município</span><br/>
                                    <label>{{ paciente.cidadeEstado }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>CEP</span><br/>
                                    <label>{{ paciente.cep | textoSemValor }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Logradouro</span><br/>
                                    <label>{{ paciente.logradouro | textoSemValor }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Número</span><br/>
                                    <label>{{ paciente.logradouroNumero | textoSemValor }}</label>
                                </v-col>
                                <v-col cols="12" md="3" sm="3" xs="6">
                                    <span>Bairro</span><br/>
                                    <label>{{ paciente.bairro | textoSemValor }}</label>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
import ConfirmModal from '@/views/components/ConfirmModal.vue'

export default {
    name: 'PacienteSalaEsperaModal',
    components: {ConfirmModal},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        paciente: {
            default: () => {
                return {}
            },
        },
    },
    data() {
        return {
            modalRemoverPaciente: false
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        acessarFichaPaciente() {
            this.$router.push({name: 'PacienteFicha', params: {id: this.paciente.idPaciente}})
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalVisualizarPacienteSalaEspera')
        },
        removerPacienteSalaEspera() {
            this.model = false
            this.$emit('removerPacienteSalaEspera', this.paciente.id)
        },
        abrirModalRemoverPaciente() {
            this.modalRemoverPaciente = true
        },
        fecharModalRemoverPaciente() {
            this.modalRemoverPaciente = false
        }
    }
}
</script>

<style scoped lang="stylus">

.container-card-paciente
    border-radius 5px
    padding 5px
    margin-bottom 10px

    span
        font-weight bold
        color #666
        font-size 14px

    label
        color black

.max-text
    max-width 60vw


</style>